export enum RouteEnum {
  Home = "/",
  Expenses = "expenses",
  ImportStatement = "import-statement",
  DebugLogs = "debug/logs",
}
